<script setup>
import { useRoute } from 'vue-router';
import { useLocalePath } from '#i18n';
import { computed } from 'vue';

defineProps({
  src: {
    type: String,
    default: undefined,
  },
  alt: {
    type: String,
    default: undefined,
  },
  height: {
    type: Number,
    default: undefined,
  },
  width: {
    type: Number,
    default: undefined,
  },
});

const route = useRoute();
const localePath = useLocalePath();

const isHome = computed(() => {
  const homePath = localePath('/');
  return route.path === homePath;
});

const homeLink = computed(() => localePath('/'));
</script>
<template>
  <div class="logo">
    <CTagDetect v-if="!isHome" :to="homeLink" class="logo__link">
      <img
        :src="src"
        :alt="alt"
        :height="height"
        :width="width"
        class="logo__image"
      />
    </CTagDetect>
    <img
      v-else
      :src="src"
      :alt="alt"
      :height="height"
      :width="width"
      class="logo__image"
    />
  </div>
</template>

<style scoped lang="scss">
.logo {
  display: flex;
  align-items: center;
  &__image {
    height: auto;
    width: 100%;
  }
}
</style>
